import { render, staticRenderFns } from "./SingleHeaderSkeleton.vue?vue&type=template&id=e3ca8c6a&"
import script from "./SingleHeaderSkeleton.vue?vue&type=script&lang=js&"
export * from "./SingleHeaderSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports